export default __webpack_public_path__ + "static/ndp3-520443872312f503eeb2c605ff1c2963.jpg";